var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderBrandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 782,
    height: 523,
    viewBox: "0 0 782 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 782,
    height: 523,
    rx: 40,
    fill: "#F8FAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.762 222.8L468.125 155.3H468.012C466.1 151.587 462.387 149 458 149H323C318.613 149 314.9 151.587 312.987 155.3H312.875L279.125 222.8H279.237C278.563 224.262 278 225.95 278 227.75V362.75C278 368.938 283.062 374 289.25 374H491.75C497.938 374 503 368.938 503 362.75V227.75C503 225.95 502.437 224.262 501.762 222.8ZM401.75 171.5H451.025L473.525 216.5H401.75V171.5ZM329.975 171.5H379.25V216.5H307.475L329.975 171.5ZM480.5 351.5H300.5V239H480.5V351.5ZM368 284H413C419.188 284 424.25 278.938 424.25 272.75C424.25 266.562 419.188 261.5 413 261.5H368C361.812 261.5 356.75 266.562 356.75 272.75C356.75 278.938 361.812 284 368 284Z",
    fill: "#94A3B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderBrandLogo);
export default __webpack_public_path__ + "static/media/PlaceholderBrandLogo.ab5b2543aaad9d1c147d7c834444c049.svg";
export { ForwardRef as ReactComponent };